import { isValidMediaUrl } from './mediaUrl';

export { isValidMediaUrl } from './mediaUrl';

export function isValidHttpUrl(value) {
  const v = String(value || '').trim();
  if (!v) return false;
  try {
    const u = new URL(v);
    return u.protocol === 'http:' || u.protocol === 'https:';
  } catch {
    return false;
  }
}

export function isUploadedMediaPath(value) {
  const v = String(value || '').trim();
  return (
    (v.startsWith('/') && v.length > 1) ||
    /^uploads\/|^lms\/uploads\//i.test(v) ||
    v.startsWith('data:') ||
    v.startsWith('blob:')
  );
}

export function getMediaUrlValidationError(value, { required = false, label = 'URL' } = {}) {
  const v = String(value || '').trim();
  if (!v) return required ? `${label} is required.` : null;
  if (!isValidMediaUrl(v)) {
    return `Enter a valid ${label.toLowerCase()} (http://, https://, or upload path).`;
  }
  return null;
}

export function getHttpUrlValidationError(value, { required = false } = {}) {
  const v = String(value || '').trim();
  if (!v) return required ? 'URL is required.' : null;
  if (!isValidHttpUrl(v)) return 'Enter a valid URL starting with http:// or https://.';
  return null;
}

/** Validates doc fields: uploads use media rules; external links require http(s). */
export function getDocUrlValidationError(value, { required = false, linkMode = false } = {}) {
  const v = String(value || '').trim();
  if (!v) return required ? 'Document URL is required.' : null;
  if (linkMode || !isUploadedMediaPath(v)) {
    return getHttpUrlValidationError(v, { required: true });
  }
  return getMediaUrlValidationError(v, { required: true, label: 'Document URL' });
}

export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_MAX_LENGTH = 128;

export function getPasswordValidationError(password) {
  const v = String(password || '');
  if (!v) return 'Password is required.';
  if (v.length < PASSWORD_MIN_LENGTH) {
    return `Password must be at least ${PASSWORD_MIN_LENGTH} characters.`;
  }
  if (v.length > PASSWORD_MAX_LENGTH) {
    return `Password must be ${PASSWORD_MAX_LENGTH} characters or fewer.`;
  }
  return null;
}

export function getPasswordMatchError(password, confirmPassword) {
  if (password !== confirmPassword) return 'Passwords do not match.';
  return null;
}
